import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const usePostCart = () => {
  const postCart = async (payload) => {
    try {
      const url = `${getApiUrl()}/cart`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postCart;
};

export const useAddItemToCart = () => {
  const addItemToCart = async (cartId, payload) => {
    try {
      const url = `${getApiUrl()}/cart/${cartId}/item`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return addItemToCart;
};
export const useAddItemsToCart = () => {
  const addItemsToCart = async (cartId, payload) => {
    try {
      const url = `${getApiUrl()}/cart/${cartId}/items`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return addItemsToCart;
};

export const useDeleteItemFromCart = () => {
  const deleteItemFromCart = async (cartId, itemId) => {
    const url = `${getApiUrl()}/cart/${cartId}/item/${itemId}`;
    const response = await axios.delete(url);
    return response.data;
  };

  return deleteItemFromCart;
};

export const useCart = (id) => {
  const urlStr = id ? `${getApiUrl()}/cart/${id}` : null;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const useCardCart = () => {
  const urlStr = `${getApiUrl()}/cart/card`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false
    }
  );
  return swr;
};

export const useCarts = ({ cardId }) => {
  const urlStr = `${getApiUrl()}/cart${cardId ? `?cardId=${cardId}` : ''}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const useGetCartSelf = () => {
  const getCartSelf = async () => {
    try {
      const url = `${getApiUrl()}/cart/self`;
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return getCartSelf;
};

export const useLinkUserToCart = () => {
  const linkUserToCart = async (cartId) => {
    try {
      const url = `${getApiUrl()}/cart/${cartId}/link-user`;
      const response = await axios.post(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return linkUserToCart;
};

export const useCreatePaymentIntent = () => {
  const createPaymentIntent = async (cartId) => {
    try {
      const url = `${getApiUrl()}/cart/${cartId}/create-payment-intent`;
      const response = await axios.post(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return createPaymentIntent;
};

export const useProcessCart = () => {
  const processCart = async (cartId, paymentIntentId) => {
    try {
      const url = `${getApiUrl()}/cart/${cartId}/process?paymentIntentId=${paymentIntentId}`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return processCart;
};
